import {useState} from "react";
import MetroAreaForm from "./MetroAreaForm";

const CreateMetroArea = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Metro Areas", url: "/metro-areas"},
        {content: "Add Metro Area", url: "/metro-areas/create"},
    ]);

    return (
        <>
            <MetroAreaForm crumbs={crumbs} title={"Add Metro Area"} btnText={"Add"}/>
        </>
    )
}
export default CreateMetroArea;